export const darkModeTheme = {
  backgroundColor: "#1e1e1e",
  primaryColor: "#fff",
  colorTextDefault: "#ccc",
};

export const lightModeTheme = {
  backgroundColor: "#F2F2F2",
  primaryColor: "#0D0D0D",
  colorTextDefault: "#4B4A4A",
};
